import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Layout from "@layout";
import SEO from "@components/seo";
import PageBreadcrumb from "../../components/pagebreadcrumb";
import PhotosDataInit from "../../components/photosdata/jatyio-bima-dibosh-2021.json";
import Data from "../../components/photosdata/Data";
import { normalizedData } from "@utils/functions";
import { Container } from "react-bootstrap";
import axios from "axios";
import { useEffect, useState } from "react";
import Preload from "../../components/preloadPage/preload";
const JatyioBimaDibosh2021 = ({ data, location, pageContext }) => {
    const [PhotosData, setJsonData] = useState(PhotosDataInit);
    const [preload, setPreload] = useState(true);
    useEffect(() => {
        axios(
            "https://admin.reliance.com.bd/api/sendJSON/62a751b0d69abc065dad2db2"
        )
            .then((resultData) => {
                setJsonData(resultData.data);
                setPreload(false);
            })
            .catch((err) => {
                console.log(err);
                setPreload(false);
            });
    }, []);
    const globalContent = normalizedData(data?.allGeneral?.nodes || []);
    return (
        <Layout
            data={{
                ...globalContent["menu"],
                ...globalContent["footer"],
            }}
        >
            {" "}
            {preload && <Preload />}
            <SEO title="Jatyio Bima Dibosh 2021" pathname="/" />
            <PageBreadcrumb
                pageContext={pageContext}
                location={location}
                title="Jatyio Bima Dibosh 2023"
            />
            <Container>
                <div className="row">
                    <Data data={PhotosData} />
                </div>
            </Container>
        </Layout>
    );
};
JatyioBimaDibosh2021.propTypes = {
    location: PropTypes.object,
    pageContext: PropTypes.object,
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allArticle: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export const query = graphql`
    query JatyioBimaDibosh2021Query {
        allGeneral {
            nodes {
                section
                id
                menu {
                    ...Menu
                }
                footer {
                    ...Footer
                }
            }
        }
        allArticle {
            nodes {
                ...Articles
            }
        }
    }
`;

export default JatyioBimaDibosh2021;
